






































import { Component, Vue } from 'vue-property-decorator';
import { LoginCredentials } from '../interfaces/loginCredentials';
import { Action, State } from 'vuex-class';
import AppMessage from 'modules/core/models/appMessage';
import { ApiResponse } from '../interfaces/apiResponse';
import { ElForm } from 'element-ui/types/form';
import { AuthStateInterface } from '../interfaces/authState';
import LanguagePicker from '@/modules/profile/components/LanguagePicker.vue';
import { Languages } from '@/modules/core/enums/languages';

@Component({
  components: {
    LanguagePicker,
  },
})
export default class Login extends Vue {
  public form: LoginCredentials = {
    username: '',
    password: '',
  };

  public validationRules!: any;
  public currentLanguage = Languages.PL;

  public loading: boolean = false;
  @Action('auth/login') private login!: (
    data: LoginCredentials,
  ) => Promise<ApiResponse>;

  @State('auth') private auth!: AuthStateInterface;

  get masterAccountId() {
    return this.auth && this.auth.user ? this.auth.user.MasterAccountId : null;
  }

  public created() {
    this.validationRules = {
      username: [
        { type: 'email', required: true, message: this.$t('forms.invalidEmail'), trigger: 'blur' },
      ],
      password: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
    };
  }

  public languageUpdated(lang: Languages) {
    this.currentLanguage = lang;
    this.$i18n.locale = lang;
  }

  public onSubmit() {
    try {
      this.loading = true;

      (this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          try {
            const apiResponse = await this.login(this.form);

            if (apiResponse.status === 200) {
              const token = this.parseJwt(apiResponse.data.access_token);

              if (token.role?.includes('admin')) {
                setTimeout(() => {
                  this.$router.push('/select-account');
                }, 500);
              } else {
                setTimeout(() => {
                  this.$router.push('/');
                }, 500);
              }

            } else {
              AppMessage.show(
                'Error while logging to panel, please try again',
                'error',
              );
              this.loading = false;
            }
          } catch (error) {
            AppMessage.show(
                'Error while logging to panel, please try again',
                'error',
              );
            this.loading = false;
          }
        } else {
          this.loading = false;
          return false;
        }
      });
    } catch (error) {
      AppMessage.show('Error while logging to panel: ' + error, 'error');
      this.loading = false;
    }
  }

  public parseJwt(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));

    return JSON.parse(jsonPayload);
  }

  public onRegister() {
    window.location.href = 'https://labelcall.com/e-landing-page/darmowakonfiguracja/';
  }
}
